/* eslint-disable react/prop-types */
import React from 'react';

import MobileGridColorFilter from './MobileGridColorFilter';
import MobileGridDefaultFilter from './MobileGridDefaultFilter';
import MobileGridGroupedFilter from './MobileGridGroupedFilter';

const MobileGridFilterRenderer = ({ facet }) => {
  if (facet?.sub_facets?.length > 0) {
    return <MobileGridGroupedFilter {...facet} />;
  }

  if (facet?.name === 'tag_color_list') {
    return <MobileGridColorFilter {...facet} />;
  }

  // TODO: handle review filter

  return <MobileGridDefaultFilter {...facet} />;
};

export default MobileGridFilterRenderer;
